import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { GraphQLModule } from './graphql.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { provideServerRendering } from '@angular/platform-server';
import { httpConfigInterceptor } from './auth/http-config.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    GraphQLModule,
    SharedModule,
    LayoutModule,
    ToastModule,
    MessageModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: httpConfigInterceptor,
      multi: true,
    },
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideServerRendering(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
